module.exports = __webpack_public_path__ + "img/icone-estrada.e9581932.svg";